import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./NavBar.css";

export default function NavBar() {
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Close drawer when route changes
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const leftLinks = [
    { to: "/search", label: "Search" },
  ];
  const bisLinks = [
    { to: "/bis/deathknight", label: "Death Knight", cls: "dk" },
    { to: "/bis/druid", label: "Druid", cls: "druid" },
    { to: "/bis/hunter", label: "Hunter", cls: "hunter" },
    { to: "/bis/mage", label: "Mage", cls: "mage" },
    { to: "/bis/paladin", label: "Paladin", cls: "paladin" },
    { to: "/bis/priest", label: "Priest", cls: "priest" },
    { to: "/bis/rogue", label: "Rogue", cls: "rogue" },
    { to: "/bis/shaman", label: "Shaman", cls: "shaman" },
    { to: "/bis/warlock", label: "Warlock", cls: "warlock" },
    { to: "/bis/warrior", label: "Warrior", cls: "warrior" },
  ];

  const isActive = (to) => location.pathname === to;

  return (
    <header className="gc-navbar">
      <div className="gc-navbar-inner">
        {isMobile && (
          <button
            className={`gc-burger ${open ? "is-open" : ""}`}
            aria-label="Open menu"
            aria-expanded={open}
            onClick={() => setOpen(!open)}
          >
            <span />
            <span />
            <span />
          </button>
        )}

        <div className="gc-brand">
          <Link to="/" className="gc-logo">
            GearChecker
          </Link>
        </div>

        <nav className="gc-nav-desktop" aria-label="Primary">
          <div className="gc-nav-left">
            {leftLinks.map((l) => (
              <Link
                key={l.to}
                className={`gc-nav-link ${isActive(l.to) ? "active" : ""}`}
                to={l.to}
              >
                {l.label}
              </Link>
            ))}

            {/* BIS dropdown (desktop) */}
            <div className="gc-dropdown">
              <span className="gc-nav-link gc-dropdown-trigger">BIS items</span>
              <div className="gc-dropdown-menu" role="menu" aria-label="BIS items">
                {bisLinks.map((l)=>(
                  <Link key={l.to} to={l.to} className={`gc-dropdown-item class-${l.cls}`}>{l.label}</Link>
                ))}
              </div>
            </div>
          </div>
          <div className="gc-nav-right"></div>
        </nav>
      </div>

      {/* Mobile drawer */}
      <aside className={`gc-drawer ${open ? "open" : ""}`} aria-hidden={!open}>
        <nav className="gc-drawer-nav" aria-label="Mobile">
          <div className="gc-drawer-group">
            {leftLinks.map((l) => (
              <Link key={l.to} className="gc-drawer-link" to={l.to}>
                {l.label}
              </Link>
            ))}
          </div>

          <hr />

          {/* Mobile BIS accordion */}
          <div className="gc-drawer-group">
            <details className="gc-accordion" open>
              <summary className="gc-accordion-summary">BIS items</summary>
              <div className="gc-accordion-panel">
                {bisLinks.map((l) => (
                  <Link key={l.to} className={`gc-drawer-link class-${l.cls}`} to={l.to}>
                    {l.label}
                  </Link>
                ))}
              </div>
            </details>
          </div>
        </nav>
      </aside>

      {open && (
        <div className="gc-drawer-backdrop" onClick={() => setOpen(false)} aria-hidden="true" />
      )}
    </header>
  );
}
